import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { useEstateOptions } from '@/api/estate-options';
import { FieldInput } from '@/components/form/field-input';
import { FieldSelect } from '@/components/form/field-select';

import type { EstateValidationSchemaType } from '../../schemas/estate-validation';

export const PropertyDetailsForm = () => {
  const { t } = useTranslation();
  const { data: estateOptions } = useEstateOptions();
  const methods = useFormContext<EstateValidationSchemaType>();

  return (
    <div className="space-y-2">
      <h4 className="text-md font-bold">{t('propertyDetails')}</h4>
      <FieldSelect
        methods={methods}
        name="estateDetails.marketType"
        label={t('marketing-type')}
        options={estateOptions?.marketingType}
      />
      <FieldSelect
        methods={methods}
        name="estateDetails.propertyType"
        label={t('property-type')}
        options={estateOptions?.propertyType}
      />
      <FieldInput
        methods={methods}
        name="estateDetails.buildingYear"
        label={t('buildingYear')}
        inputProps={{ type: 'number', maxLength: 4 }}
      />
    </div>
  );
};
